import * as React from "react";
import TeamsBaseComponent, {ITeamsBaseComponentState} from "msteams-react-base-component";
import {PrimaryButton, TextField, ShimmeredDetailsList, IColumn} from "office-ui-fabric-react";
import {AppProxy} from "../../models";

export interface IApplicationProxiesState extends ITeamsBaseComponentState {}

export interface IApplicationProxiesProps {
    appProxies: AppProxy[];
    deleteAppProxy: (item: AppProxy) => Promise<void>;
    startEditAppProxyDetails: () => Promise<void>;
    deleteAppProxyInfo: () => Promise<void>;
    disabled: boolean;
    columns: IColumn[];
}

export class ApplicationProxies extends TeamsBaseComponent<IApplicationProxiesProps, IApplicationProxiesState> {
    constructor(props: IApplicationProxiesProps) {
        super(props);
    }

    public render() {
        return (
            <div>
                <p>AppProxy details enabled for this tenant</p>

                <div>
                    <div className="row" style={{paddingTop: "30px", width: "100%"}}>
                        {this.props.appProxies && (
                            <ShimmeredDetailsList
                                items={this.props.appProxies}
                                enableShimmer={false}
                                columns={this.props.columns}
                                ariaLabelForShimmer="Content is being fetched"
                                ariaLabelForGrid="Application Urls"
                                isHeaderVisible={true}
                            />
                        )}
                    </div>
                </div>
                <div style={{padding: "30px 0px 30px 0px"}}>
                    <PrimaryButton
                        style={{marginTop: "20px"}}
                        onClick={this.props.startEditAppProxyDetails}
                        text={"Edit"}
                        className={"authinput"}
                    />
                    &nbsp;&nbsp;&nbsp;
                    <PrimaryButton
                        style={{marginTop: "20px"}}
                        onClick={this.props.deleteAppProxyInfo}
                        text={"Delete"}
                        className={"authinput"}
                    />
                </div>
            </div>
        );
    }
}
